import { render, staticRenderFns } from "./TelegramOtpDetail.vue?vue&type=template&id=6bd40ec6&"
import script from "./TelegramOtpDetail.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports